var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleMeets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8707 12.3631C14.1363 12.2424 14.2541 11.9454 14.2541 11.6145V4.50754C14.2541 4.22455 14.1277 3.94476 13.8817 3.81116C13.6244 3.67143 13.302 3.72513 12.9857 3.97743L11.2928 5.33075V3.5066C11.2928 3.50058 11.2925 3.49457 11.2919 3.4886C11.2613 3.19634 11.1313 2.92345 10.9235 2.71567C10.7157 2.50789 10.4428 2.37783 10.1506 2.34728C10.1484 2.34705 10.1374 2.34656 10.1326 2.34635H3.72518C3.67906 2.34635 3.63483 2.36475 3.60233 2.39747L0.450601 5.56999C0.418373 5.60243 0.400273 5.64631 0.400273 5.69204V12.6003C0.396371 12.7537 0.423303 12.9064 0.47952 13.0492C0.536178 13.1932 0.621388 13.3242 0.730024 13.4344C0.838661 13.5445 0.96848 13.6316 1.11165 13.6902C1.25407 13.7486 1.40678 13.7777 1.56066 13.7757H10.1326C10.1387 13.7757 10.1447 13.7754 10.1508 13.7748C10.4455 13.7436 10.7203 13.6112 10.9284 13.4002C11.1365 13.1892 11.265 12.9126 11.2921 12.6174C11.2926 12.6122 11.2928 12.6069 11.2928 12.6016V10.7913L12.9858 12.1447C13.2885 12.3861 13.6065 12.4832 13.8707 12.3631ZM3.89837 10.2568H7.98178V5.8652H3.89837V10.2568Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMeets);
export default __webpack_public_path__ + "static/media/google-meets.ee749613bdc64a76aacecd74b78f9e97.svg";
export { ForwardRef as ReactComponent };